import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InactiveMapState {
  [id: string]: {
    isActive: boolean;
  };
}

const initialState: InactiveMapState = {};

const inactiveMapSlice = createSlice({
  name: 'inactiveMap',
  initialState,
  reducers: {
    markAsInactive: (state, action: PayloadAction<{ id: string }>) => {
      state[action.payload.id] = { isActive: false };
    },
    markAsActive: (state, action: PayloadAction<{ id: string }>) => {
      state[action.payload.id] = { isActive: true };
    },
  },
});

export const { markAsInactive, markAsActive } = inactiveMapSlice.actions;
export default inactiveMapSlice.reducer;
